export default {
	about: 'À propos',
	about_the_program: 'À propos du programme',
	acc_score: 'Score accumulé',
	accept: "J'accepte",
	activities: 'Activités',
	activity: 'activité',
	add_a_review: 'Ajouter un commentaire',
	add_image: 'Ajouter une image',
	address: 'Adresse',
	address_required: 'Adresse requise',
	all: 'Tous',
	all_f: 'Toutes',
	an_error_has_occurred: 'Une erreur est survenue',
	an_unexpected_error_has_occurred_try_again: "Une erreur imprévue s'est produite. Réessayer.",
	and: 'et',
	answer: 'Réponse',
	answer_plural: 'Réponses',
	answer_reported_successfully: 'Réponse signalée avec succès',
	answered: 'Répondu',
	apply: 'Postuler',
	approved: 'Approuvé',
	areas: 'Domaines',
	at: 'à',
	attention: 'Attention',
	audio: 'Audio',
	available_in: 'Disponible en',
	back: 'Retour',
	back_to_training: 'Retour à la formation',
	badge: 'Badge | Badges',
	badges: 'Badges',
	before_starting_this: ' avant de commencer ça',
	bookmarks: 'Préférés',
	browser_window_blocked_click: 'Votre navigateur a bloqué la fenêtre, veuillez cliquer',
	by: 'par',
	calendar: 'Calendrier',
	campaign: 'Campagne',
	campaigns: 'Campagnes',
	cancel: 'Annulation',
	cant_watch_click_here: 'Cliquez ici pour regarder en plein écran',
	categories: 'Catégories',
	category: "Zone d'entraînement",
	certificate: 'Certificat | Certificats',
	certificates: 'Certificats',
	check_scorm_finished: "Vérifier la fin de l'activité",
	clear_date: 'Effacer la date',
	clear_filters: 'Effacer les filtres',
	clear_notifications: 'Notifications claires',
	close: 'Fermer',
	code: 'Code',
	code_a_z: 'Code A-Z',
	compressed_file: 'Fichier Compressé',
	confirm: 'Confirmer',
	confirm_report_answer: 'Confirmer le rapport de réponse',
	confirm_report_topic: 'Confirmer le rapport sur le sujet',
	confirm_reporting_this_answer_this_should_be_done_only_with_answers_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		"Confirmer pour signaler cette réponse? Cela ne doit être fait qu'avec des réponses qui ne respectent pas les règles de la plateforme. Un message sera envoyé aux modérateurs",
	confirm_reporting_this_topic_this_should_be_done_only_with_topics_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		"Confirmez avoir signalé ce sujet? Cela ne devrait être fait qu'avec des sujets qui ne suivent pas les règles de la plateforme. Un message sera envoyé aux modérateurs",
	contact_us: 'Nous contacter',
	content: 'Contenu',
	content_deadline: "Date limite d'accès au contenu",
	cookies_custom: 'Cookies personnalisés',
	cookies_custom_information:
		'Lorsque vous accédez à cette plateforme, des cookies et certaines données liées à votre terminal peuvent être collectés afin que nous puissions vous proposer des contenus et formations personnalisés.',
	cookies_fonctionnels: 'Cookies fonctionnels',
	cookies_fonctionnels_information:
		'Ils sont utilisés pour vous reconnaître lorsque vous accédez à la plateforme, enregistrer vos préférences de configuration et protéger votre utilisateur. Ils ne peuvent pas être désactivés car ils sont indispensables au fonctionnement de la plateforme.',
	cookies_policy: 'Politique de cookies',
	cookies_policy_information:
		'Cette plateforme utilise des cookies pour assurer un service plus efficace et personnalisé. En acceptant, vous consentez à leur utilisation.',
	cookies_settings: 'Paramètres des cookies',
	copyright: 'Droits d’auteur',
	correct: 'Correct',
	country_of_residence: 'Pays de résidence',
	country_you_want_to_access: 'Pays auquel vous souhaitez accéder',
	course: 'Cours',
	course_price: 'Prix',
	creation_date: 'Date de création',
	creator: 'Créateur',
	crop: 'Découper',
	crop_image: 'Recadrer l’image',
	date: 'Date',
	description: 'La description',
	divorced: 'Divorcé',
	document: 'Document',
	done: 'Terminée',
	doubts_about_training: "Des doutes sur l'entraînement",
	download: 'Téléchargez',
	download_app: "Téléchargez l'app",
	download_our_app: 'Téléchargez notre application',
	download_our_app_information:
		"Connaissez-vous déjà notre application ? Profitez de tous nos contenus également depuis votre iPhone ou Android. Téléchargez maintenant, c'est gratuit !",
	downloading_content: 'Téléchargement de contenu',
	downloads: 'Téléchargements',
	duration: 'La durée',
	earn_points: 'Gagner des Points',
	earned: 'Gagnés',
	earning_points: 'Gagner des Points',
	email: 'Courriel',
	enter: 'Entrer',
	error_loading_data:
		"Une erreur s'est produite lors du chargement des informations. Réessayez plus tard.",
	events: 'Mes Événements',
	excel_file: 'Fichier Excel',
	extensions: 'Extensions',
	faq: 'FAQ',
	favorite_course: 'Cours Préféré',
	favorite_trail: 'Piste Préféré',
	featured_rewards: 'Prix en vedette',
	file: 'Fichier',
	file_download_failed: 'Le téléchargement du fichier a échoué',
	file_download_finished: 'Téléchargement du fichier terminé',
	file_download_started: 'Le téléchargement du fichier a commencé',
	filters: 'Filtres',
	filter_category: 'Filtrer par catégorie',
	filter_sort_by: 'Trier par',
	finished: 'Terminées',
	follower: 'Suiveur',
	free: 'gratuit',
	frequently_asked_questions: 'Questions fréquentes',
	full_name: 'Nom complet',
	go_to_class: 'Aller en classe',
	groups: 'Groupes',
	have_any_doubt_sugestion_comment_or_compliment_about_the_intel_rewards_you_program_send_us_a_message:
		'Si vous avez des questions, des commentaires ou des suggestions sur le programme Intel Rewards You, envoyez-nous un message.',
	headquarter: 'Chaîne / Entreprise',
	headquarters: 'Chaînes / Entreprises',
	help: 'Aide',
	helper_new_password: 'Votre mot de passe doit posséder 6 caractères.',
	helper_password_low: 'Votre mot de passe est faible',
	helper_password_medium: 'Votre mot de passe est moyen',
	helper_password_strong: 'Votre mot de passe est fort',
	here: 'ici',
	home: 'Accueil',
	hour: 'heure',
	hour_plural: 'heures',
	how_do_you_rate_this_training: 'Comment évaluez-vous cette formation?',
	image: 'Image',
	image_from_device: "Image de l'appareil",
	image_from_url: "Image d'adresse",
	image_size: 'Taille de l’image',
	image_url: "Adresse de l'image",
	in_progress: 'En cours',
	influencer: 'Influenceur',
	insert_sales: 'Insérer les ventes',
	instructors: "L'équipe",
	intel_lovers: 'Intel Friends',
	introduction: 'Introduction',
	invalid_document: 'Document invalide',
	invited: 'Client',
	items_per_page: 'Items par page',
	itp_points: 'Points ',
	joined_the_class: 'rejoint la classe',
	keep_watching: 'Continuer de regarder',
	know_more: 'Savoir plus',
	language: 'Langue',
	last: 'Le plus récent',
	last_name: 'Nom de famille',
	legal_information: 'Information Légale',
	lets_talk_about_privacy: 'Parlons de la vie privée!',
	level: 'Niveau',
	library: 'Bibliothèque',
	like: 'Comme',
	liked: 'Aimer',
	likes: 'Commes',
	live_class: 'Cours en Direct',
	live_classes: 'Cours en Direct',
	loading_data: 'Chargement des données',
	loading_news: 'Chargement des actualités',
	make_sure_all_mandatory_fields_are_completed:
		'Assurez-vous que tous les champs obligatoires sont remplis',
	make_sure_that_all_fields_are_filled_in: 'Assurez-vous que tous les champs sont remplis.',
	married: 'Marié',
	meet_the_team: "Rencontrez l'équipe",
	message: 'Message',
	message_sent_successfully: 'message envoyé avec succès',
	minute: 'minute',
	minute_plural: 'minutes',
	name: 'Nom',
	new_certificate_in_course: 'Nouveau certificat dans le cours {title}',
	new_certificate_in_trail: 'Nouveau certificat dans le piste {title}',
	new_download_code: 'Nouveau download code',
	news: 'Informations',
	next_activity: 'Prochaine activité',
	no: 'Non',
	no_data_avaliable: 'Données indisponibles',
	no_news_are_available_at_the_moment: 'Aucune nouvelle n’est disponible pour l’instant.',
	no_news_are_available_with_the_selected_filter:
		'Aucune actualité disponible pour le filtre sélectionné',
	no_pre_visualization_available: 'Pas de pré visualisation disponible',
	no_results: 'Aucun résultat',
	no_results_found: 'Aucun résultat trouvé',
	no_vacancy: 'Épuisé',
	not_allowed_or_page_not_found: 'Non trouvé ou n’ont pas l’autorisation d’accéder.',
	not_answered: 'Sans réponse',
	not_answered_f: 'Sans réponse',
	notification: 'Notification',
	notifications: 'Notifications',
	number_required: 'Le numéro est requis',
	neighborhood_required: 'Quartier requis',
	state_required: 'État requis',
	city_required: 'Ville requise',
	zip_code_required: 'Code postal requis',
	complete_your_registration: 'Complétez votre inscription',
	select_your_profile: "Sélectionnez votre profil",
	fill_in_later: 'Remplir plus tard',
	document_required: 'Document est requis',
	document_already_registered: 'Document déjà enregistré',
	no_registered_profile: "Aucun profil enregistré. Contactez le gestionnaire de la plateforme pour valider l'authentification.",
	login_with_google: 'Connexion Google',
	error_signing_in_with_google: 'Erreur lors de la connexion avec Google, veuillez réessayer plus tard.',
	birthday_must_be_before_today: 'Remplissez correctement le champ',
	please_fill_out_the_form_correctly: 'Veuillez remplir le formulaire correctement.',
	your_accounts_has_been_completed_successfully: 'Votre compte a été complété avec succès',
	register_not_unique: 'Registre non unique',
	of: 'de',
	online_courses: 'Des Cours en ligne',
	only_available_when_finished_training: 'Disponible uniquement une fois la formation terminée',
	order_by: 'Trier par',
	origin: 'Origine',
	password: 'Mot de passe',
	pdf_file: 'Fichier PDF',
	percentage: 'Pourcentage',
	place: 'Lieu',
	platform_meta_description: 'Powered by Take 5 LMS',
	please_wait_activities_loading: 'Chargement des activités, veuillez patienter......',
	podcasts: 'Podcasts',
	point: 'Point',
	point_plural: 'Points',
	points: 'Points',
	points_earned: 'Points Gagnés',
	points_table: 'Tableau de Points',
	pontuation: 'Ponctuation',
	post_a_comment: 'Ajouter un commentaire',
	powerpoint_file: 'Fichier PowerPoint',
	presential: 'Présentiel',
	presential_courses: 'Cours Présentiels',
	privacy_policy: 'Politique de Confidentialité',
	price: 'Prix',
	profile: 'Profil',
	progress: 'Progrès',
	ranking: 'Classement',
	reaction_evaluation: 'Évaluation de la Réaction',
	received_a_certificate_in_course: '{name} a reçu un certificat dans le cours {title}',
	received_a_certificate_in_trail: '{name} a reçu un certificat dans le piste {title}',
	redemption_code: 'Code de remboursement',
	refuse: 'Refuser',
	regionals: 'Régionaux',
	registered: 'Inscrit',
	reproved: 'Désapprouvé',
	requirement: 'Conditions',
	response_sent_successfully: 'Réponse envoyée avec succès',
	result_found: 'résultat trouvé | résultats trouvés',
	retry_test: 'Réessayer',
	return_to_activities: 'Retour aux activités',
	reviews: 'Commentaires',
	reward_store: 'Magasin de récompense',
	reward_redemption: 'Rescue de récompense',
	rewards_you: 'Rewards You',
	rotate_device_for_better_experience: 'Retournez votre appareil pour une meilleure expérience!',
	save: 'Sauvegarder',
	save_data_success: 'Les données ont bien été enregistrées',
	score: 'Résultat | Résultats',
	score_statement: 'Relevé de points',
	scorm_finished: 'Activité terminé',
	scorm_not_finished: 'Activité pas fini',
	search: 'Rechercher',
	search_for_your_address: 'Recherchez votre adresse',
	search_for_zip_address_or_city: 'Recherchez par votre code postal, adresse ou ville',
	see_all_content: 'Voir tout le contenu',
	see_more: 'Voir plus',
	select_a_file: 'Sélectionner un fichier',
	select_a_image: 'Sélectionner une image',
	selected_campaign: 'Campagne Sélectionnée',
	seller_hint:
		"Recherchez votre magasin en tapant simplement le numéro d'enregistrement de l'entreprise (sans utiliser de points, de tirets ou de barres obliques).",
	send: 'Envoyer',
	set_cookies: 'Définir des cookies',
	show_certificate: 'Afficher le certificat',
	single: 'Célibataire',
	size: 'Taille',
	start_reaction_assessment: "Commencer l'évaluation de la réaction",
	status: 'Statut',
	support: 'Soutien',
	tags: 'Saillants',
	take_course: 'Suivre un cours',
	terms_and_conditions: 'Termes et Conditions',
	test: 'Épreuve',
	there_are_no_codes_available:
		"Il n'y a pas de codes disponibles pour libérer une application sur l'App Store. S'il vous plaît contactez le support.",
	this_content_will_be_available_on: 'Ce contenu sera disponible sur',
	this_website_is_best_viewed_in_google_chrome_and_mozilla_firefox:
		'Ce site est optimisé pour Google Chrome et Mozilla Firefox.',
	timezone: 'Fuseau horaire',
	title: 'Titre',
	title_a_z: 'Titre A-Z',
	to_access_the_class: 'pour accéder à la classe',
	to_do: 'À faire',
	to_understand_why_we_use_cookies: "Pour plus d'informations, cliquez ici.",
	total_results: 'Total des résultats',
	topic_reported_successfully: 'Sujet signalé avec succès',
	trail: 'Piste',
	trail_plural: 'Pistes',
	trails: 'Pistes',
	training: 'Formation',
	training_plural: 'Formations',
	type: 'Type',
	type_to_search: 'Tapez pour rechercher',
	unfavorite_course: 'Cours Dépréféré',
	unfavorite_trail: 'Piste Dépréféré',
	unlike: 'Ne pas aimer',
	upload_photos: 'Envoyer des photos',
	user: 'Utilisateur',
	user_environment: 'Environnement utilisateur',
	vimeo: 'Vimeo',
	we_were_unable_to_send_your_message_please_try_again_later:
		"Nous n'avons pas pu envoyer votre message, veuillez réessayer plus tard",
	webcast: 'Webinaire',
	webcasts: 'Webinaires',
	webinar: 'Webinaire',
	webinars: 'Webinaires',
	widowed: 'Veuf',
	window_blocked: 'Onglet bloqué',
	workload: 'Charge de travail',
	wowza: 'Wowza',
	yes: 'Oui',
	you_already_reviewed: 'Vous avez déjà ajouté un avis',
	you_must_complete_all_required_training_before_redeeming:
		"Vous devez suivre toutes les formations requises avant d'utiliser",
	you_must_finish_the_test: 'Veuillez compléter le test',
	you_need_to_end_the_training_before_you_can_respond_to_the_reaction_assessment:
		"Vous devez mettre fin à la formation avant de pouvoir répondre à l'évaluation de la réaction",
	you_need_to_finish_the_content: 'Vous devez finaliser le contenu ',
	your_answer: 'Ta réponse',
	your_rating: 'Votre note',
	your_text_is_longer_than_256_characters: 'Votre texte comporte plus de 256 caractères',
	youtube: 'YouTube',
	zip_code: 'Code postal',
	oldest: 'Le plus ancien',
	correct_answer: 'Question correcte',
	incorrect_answer: 'Question incorrecte',
	drills: 'Drills',
	badge_title_shared: 'Regarde la nouvelle médaille que j’ai gagnée',
	badge_title_earned: 'Félicitations, tu as gagné une nouvelle médaille !',
	badge_button_text_claim: 'Accepter la médaille',
	challenge_of_the_day: 'Défi du jour',
	recall_and_test_your_knowledge_with_quick_questions: 'Rappelez-vous et testez vos connaissances avec {count} question rapide | Rappelez-vous et testez vos connaissances avec {count} questions rapides',
	correct_answer: 'Réponse correcte',
	incorrect_answer: 'Réponse incorrecte',
	can_you_answer_this_question: 'pouvez-vous répondre à cette question?',
	unavailable: "Indisponible",
	you_already_have_a_certificate_in_one_event_on_this_catalog: "Vous êtes déjà inscrit ou avez un certificat pour un événement de ce catalogue {catalog}.",
	no_category: 'Sans catégorie',
	no_access_to_send_points: "Malheureusement, vous n'avez pas l'autorisation d'envoyer des points. Veuillez contacter l'administrateur de la plateforme.",
	search_by_ia: "Recherchez l'IA",
	please_log_in_to_the_platform_first: "Pour télécharger l'application, veuillez d'abord vous connecter à la plateforme",
	required_update_title: 'Mise à Jour Obligatoire',
	required_update_message_ios: 'Une nouvelle version de l\'application est disponible avec des améliorations essentielles. Pour continuer, veuillez la mettre à jour manuellement en suivant ces étapes:<br><br><b>1.</b> Ouvrez l\'application <b>App Store</b>.<br><b>2.</b> Appuyez sur l\'icône de votre profil (coin supérieur droit).<br><b>3.</b> Faites défiler vers le bas jusqu\'à la section des mises à jour en attente et appuyez sur <b>Mettre à jour</b> à côté de notre application.',
	required_update_message_android: 'Une nouvelle version de l\'application est disponible avec des améliorations essentielles. Pour continuer à utiliser la plateforme, cliquez sur le bouton ci-dessous pour être redirigé vers l\'App Store et effectuer la mise à jour automatiquement.',
	required_update_button_android: 'Mettre à jour'
}
